import { useEffect, useState, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { GET_ADVOCATE_TEMPLET_LIST } from "../../utils/apiConstants";
import useApi from "../../hooks/useApi";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TemplateCard from "../../components/Common/TemplateCard";

export default function TemplateSlider() {
  const { apiRequest } = useApi();

  const [templates, settemplates] = useState([]);

  const getTemplates = useCallback(async () => {
    try {
      const response = await apiRequest({
        url: GET_ADVOCATE_TEMPLET_LIST,
        method: "post",
      });
      settemplates(response?.data?.templates);
    } catch (error) {
      console.log("error in getTemplet list :", error);
    }
  }, [apiRequest]);

  useEffect(() => {
    getTemplates();
  }, [getTemplates]);

  return (
    <div className="relative mt-5">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        pagination={false}
        className="mySwiper pt-3"
        navigation={true}
        breakpoints={{
          580: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        }}
        modules={[Pagination, Navigation]}
      >
        {templates.map((data, i) => {
          return (
            <SwiperSlide key={i}>
              <TemplateCard
                key={data.id}
                templateId={data.id}
                ownerTemplateId={data.id}
                templateName={data.name}
                templateDescription={data.description}
                advocateName={
                  data.user?.fullName === undefined
                    ? data.user?.email?.split("@")[0]
                    : data.user?.fullName
                }
                profileImgSrc={data.user?.prfileIMG}
                templateamount={data.amount}
                templateCity={data.city}
                templateState={data.state}
                className="mb-4"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
